enum CampaignStatus {
  INACTIVE = 'INACTIVE',
  ACTIVE = 'ACTIVE',
  DRAFT = 'DRAFT',
  APPROVAL_REQUIRED = 'APPROVAL_REQUIRED',
}

export default CampaignStatus;
